import { render } from "./PopupRevokeApplication.vue?vue&type=template&id=a88ee7ae"
import script from "./PopupRevokeApplication.vue?vue&type=script&lang=js"
export * from "./PopupRevokeApplication.vue?vue&type=script&lang=js"

import "./PopupRevokeApplication.vue?vue&type=style&index=0&id=a88ee7ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__